import { FormAction } from '@/types';
import { RouteRecordRaw } from 'vue-router';
import WorkSchedulePage from '@/views/pages/work-schedule/WorkSchedulePage.vue';
import WorkScheduleDetailPage from '@/views/pages/work-schedule/WorkScheduleDetailPage.vue';
import { validateIdAsPositiveIntegerGuard } from '../routeGuards';
import WorkScheduleFormPage from '@/views/pages/work-schedule/WorkScheduleFormPage.vue';

const workScheduleRouter: RouteRecordRaw = {
    name: 'WorkSchedule',
    path: 'work-schedules',
    children: [
        {
            name: 'ListWorkSchedule',
            path: '',
            component: WorkSchedulePage,
        },
        {
            name: 'ViewWorkScheduleById',
            path: ':id',
            component: WorkScheduleDetailPage,
            beforeEnter: [validateIdAsPositiveIntegerGuard],
            meta: { isLevelLocked: true },
        },
        {
            name: 'EditWorkScheduleById',
            path: ':id/edit',
            component: WorkScheduleFormPage,
            beforeEnter: [validateIdAsPositiveIntegerGuard],
            props: { action: FormAction.EDIT },
            meta: { isLevelLocked: true },
        },
        {
            name: 'CreateWorkSchedule',
            path: 'create',
            component: WorkScheduleFormPage,
            props: { action: FormAction.CREATE },
            meta: { isLevelLocked: true },
        },
    ],
};

export default workScheduleRouter;
